import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";
import SocialMediaIcons from "./SocialMediaIcons";
const EnhancedFooter = () => {
  return <footer className="bg-[#0B0D14] pt-16 pb-8 border-t border-gray-800">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Brand Column */}
          <div>
            <div className="text-2xl font-bold mb-4">
              <span className="text-white">tok</span>
              <span className="text-[#00E5FF]">collect</span>
            </div>
            <p className="text-gray-400 mb-4">Download any TikTok Collection with 1 click anytime, anywhere!</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              {["Home", "Features", "How it Works", "FAQ"].map(link => <li key={link}>
                  <a href="#" className="text-gray-400 hover:text-[#00E5FF] transition-colors">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-white font-semibold mb-4">Support</h3>
            <ul className="space-y-3">
              {["Help Center", "Contact Us", "Privacy Policy", "Terms of Service"].map(link => <li key={link}>
                  <a href="#" className="text-gray-400 hover:text-[#00E5FF] transition-colors">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Subscribe */}
          <div>
            <h3 className="text-white font-semibold mb-4">Stay Updated</h3>
            <p className="text-gray-400 mb-4">
              Subscribe to our newsletter for the latest updates
            </p>
            <div className="flex gap-2">
              <Input placeholder="Enter your email" className="bg-[#1A1E2C] border-gray-800 text-white" />
              <Button className="bg-[#00E5FF] hover:bg-[#00E5FF]/90 text-[#151820]">
                <Mail className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            © 2025 Tokcollect. All rights reserved.
          </p>
          <SocialMediaIcons />
        </div>
      </div>
    </footer>;
};
export default EnhancedFooter;